export default {
    oidc: {
      clientId: '0oa8m61ns6vJ0Uegt5d7',
      issuer: 'https://login.roguefitness.com/oauth2/default',
      redirectUri: window.location.origin + '/login/callback',
      scopes: ['openid', 'profile', 'email'],
      tokenManager: {
        autoRenew: true
      }
    }
  }